import Press, {
  getServerSideProps as hgetServerSideProps,
} from '@pages/myapp/parking/pressroom/[id]';
import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const ret = await hgetServerSideProps(ctx);
  return ret;
};

export default Press;
